import React from "react"
import { MenuItem } from "@hg/recall-frame"

import { Pool } from "./Pool"
import { Progress } from "./Progress"
import { Record } from "./Record"
import { Task } from "./Task"
import RewardRule from "@/components/Reward/components/Rule"
import { showRuleModal } from "../../components/Modals/Rules"

export const menus: MenuItem[] = [
    {
        id: "task",
        type: "view",
        render: () => <Task />,
    },
    {
        id: "progress",
        type: "view",
        render: () => <Progress />,
    },
    {
        id: "record",
        type: "view",
        render: () => <Record />,
    },
    {
        id: "pool",
        type: "view",
        render: () => <Pool />,
    },
    {
        id: "rule",
        type: "action",
        onClick: showRuleModal,
    },
]

export const titleMap = {
    task: "menu.tasks",
    progress: "menu.progress",
    record: "menu.record",
    pool: "menu.pool",
    rule: "menu.rule"
}
